/* Picura Formular-Kern — gemeinsam fuer Anfrage, Branchen-Check, Pakete, Rueckruf.

   Warum ein Kern: Bis Oktober 2026 trug jedes Formular seine eigene Kopie von
   Versand, Ergebnis-Empfang, Honeypot und Tracking. Der Empfang pruefte den
   Absender nicht — standen zwei Formulare auf einer Seite, zeigte ein Erfolg
   in beiden „Danke" und zaehlte die Anfrage doppelt. Und `generate_lead` per
   dataLayer erreichte GA4 nie, weil der Google-Tag in Shopifys Sandbox-Pixel
   laeuft. Jetzt: Shopify.analytics.publish (ein Custom Pixel leitet weiter),
   Absenderpruefung, Herkunft und Anfragenummer an einer Stelle.

   Form-API (picura-designer.de/form-api/send-form, Probe 09.10.2026): verlangt
   Name, E-Mail UND Telefon, prueft aber kein Format, und zeigt in der Mail nur
   das Feld `nachricht`. Fehlt bewusst eines, wird es mit „nicht angegeben"
   gefuellt — siehe fehlend().

   Keine personenbezogenen Daten in Tracking-Ereignissen. */
(function () {
  'use strict';
  if (window.PicuraForm) return;

  var K_ATTR = 'picura-attr';
  var K_KONTEXT = 'picura-kontext';
  var K_KONTAKT = 'picura-kontakt';
  var K_FORTSCHRITT = 'picura-fortschritt';
  var FEHLT = 'nicht angegeben';

  function speicher(k, v) {
    try {
      if (v === undefined) return JSON.parse(sessionStorage.getItem(k) || 'null');
      if (v === null) sessionStorage.removeItem(k);
      else sessionStorage.setItem(k, JSON.stringify(v));
    } catch (e) { /* privater Modus */ }
    return null;
  }
  function zwei(n) { return (n < 10 ? '0' : '') + n; }

  /* ---------- Anfragenummer ---------- */
  function leadId() {
    var d = new Date();
    var z = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789', r = '';
    for (var i = 0; i < 4; i++) r += z.charAt(Math.floor(Math.random() * z.length));
    return 'PIC-' + String(d.getFullYear()).slice(2) + zwei(d.getMonth() + 1) + zwei(d.getDate()) + '-' + r;
  }

  /* ---------- Herkunft, Kontext, Kontakt, Fortschritt ---------- */
  function herkunft() { return window.__picuraAttr || speicher(K_ATTR) || {}; }
  function kontext(neu) {
    var c = speicher(K_KONTEXT) || {};
    if (neu) {
      Object.keys(neu).forEach(function (k) { if (neu[k]) c[k] = neu[k]; });
      speicher(K_KONTEXT, c);
    }
    return c;
  }
  /* Kontaktdaten nur fuer diese Sitzung, damit ein zweites Formular (etwa die
     Pakete nach dem Branchen-Check) nicht noch einmal fragt. */
  function kontakt(neu) {
    if (neu === null) { speicher(K_KONTAKT, null); return {}; }
    var c = speicher(K_KONTAKT) || {};
    if (neu) {
      Object.keys(neu).forEach(function (k) { if (neu[k] && neu[k] !== FEHLT) c[k] = neu[k]; });
      speicher(K_KONTAKT, c);
    }
    return c;
  }
  function fortschritt(neu) {
    if (neu === undefined) return speicher(K_FORTSCHRITT);
    speicher(K_FORTSCHRITT, neu ? Object.assign({ zeit: Date.now() }, neu) : null);
    try { document.dispatchEvent(new CustomEvent('picura:fortschritt', { detail: neu })); } catch (e) { /* alt */ }
    return neu;
  }

  /* ---------- Tracking ---------- */
  var warteschlange = [];
  function veroeffentlichen(name, daten) {
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, daten);
        return true;
      }
    } catch (e) { /* egal */ }
    return false;
  }
  function track(name, daten) {
    daten = daten || {};
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push(Object.assign({ event: name }, daten)); } catch (e) { /* egal */ }
    if (!veroeffentlichen(name, daten)) warteschlange.push([name, daten]);
  }
  window.addEventListener('load', function () {
    var q = warteschlange; warteschlange = [];
    q.forEach(function (x) { if (!veroeffentlichen(x[0], x[1])) warteschlange.push(x); });
  });
  function lead(daten) {
    track('picura_lead', daten);
    try {
      window.dataLayer.push({ event: 'generate_lead', form_type: daten.form_type, form_context: daten.branche || daten.seite || '', value: daten.value || undefined, currency: daten.value ? 'EUR' : undefined, lead_id: daten.lead_id });
    } catch (e) { /* egal */ }
    try {
      var ok = window.Shopify && window.Shopify.customerPrivacy && window.Shopify.customerPrivacy.marketingAllowed();
      if (ok && typeof window.fbq === 'function') {
        window.fbq('track', 'Lead', daten.value ? { value: daten.value, currency: 'EUR' } : {}, { eventID: daten.lead_id });
      }
    } catch (e) { /* egal */ }
  }
  /* Telefon-, WhatsApp- und Mail-Links seitenweit zaehlen */
  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('a[href^="tel:"], a[href*="wa.me/"], a[href^="mailto:"]') : null;
    if (!a) return;
    var h = a.getAttribute('href') || '';
    var methode = h.indexOf('tel:') === 0 ? 'telefon' : (h.indexOf('mailto:') === 0 ? 'email' : 'whatsapp');
    var ort = a.closest('[id^="shopify-section-"]');
    track('picura_contact_click', { method: methode, location: ort ? ort.id.replace(/^shopify-section-(template--\d+__)?/, '') : 'seite' });
  }, true);

  /* ---------- Pruefung ---------- */
  function emailOk(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(String(v || '').trim()); }
  function telefonOk(v) { return String(v || '').replace(/\D/g, '').length >= 6; }
  var TIPPFEHLER = { 'gmail.con': 'gmail.com', 'gmail.de': 'gmail.com', 'gmial.com': 'gmail.com', 'gmai.com': 'gmail.com', 'googlemail.con': 'googlemail.com', 'gmx.dee': 'gmx.de', 'gmx.con': 'gmx.de', 'web.dee': 'web.de', 'web.com': 'web.de', 't-online.dee': 't-online.de', 'tonline.de': 't-online.de', 'outlook.de': 'outlook.de', 'hotmail.de': 'hotmail.de', 'yahoo.dee': 'yahoo.de' };
  function emailVorschlag(v) {
    var m = String(v || '').trim().toLowerCase().match(/^([^@\s]+)@([^@\s]+)$/);
    if (!m || !TIPPFEHLER[m[2]] || TIPPFEHLER[m[2]] === m[2]) return '';
    return m[1] + '@' + TIPPFEHLER[m[2]];
  }
  /* „Max Peter Mustermann" -> Vorname „Max Peter", Nachname „Mustermann" */
  function nameTeilen(voll) {
    var t = String(voll || '').trim().replace(/\s+/g, ' ').split(' ');
    if (t.length < 2) return { vorname: t[0] || '', nachname: '–' };
    return { vorname: t.slice(0, -1).join(' '), nachname: t[t.length - 1] };
  }
  function fehlend(wert) { return String(wert || '').trim() || FEHLT; }

  /* ---------- Nachrichtentext ---------- */
  function geraet() { return window.matchMedia && window.matchMedia('(max-width: 749px)').matches ? 'mobil' : (window.matchMedia('(max-width: 1199px)').matches ? 'Tablet' : 'Desktop'); }
  function dauer(ms) { var s = Math.max(0, Math.round(ms / 1000)); return Math.floor(s / 60) + ':' + zwei(s % 60) + ' min'; }
  function herkunftZeilen(extra) {
    var a = herkunft(), c = kontext(), z = [];
    var einstieg = a.landing ? 'Einstieg ' + a.landing : '';
    if (einstieg && a.zeit) { var d = new Date(a.zeit); einstieg += ' (' + zwei(d.getDate()) + '.' + zwei(d.getMonth() + 1) + '. ' + zwei(d.getHours()) + ':' + zwei(d.getMinutes()) + ')'; }
    if (einstieg) z.push(einstieg);
    z.push('Referrer ' + (a.ref || 'direkt'));
    var utm = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'].filter(function (k) { return a[k]; }).map(function (k) { return k + '=' + a[k]; });
    if (utm.length) z.push(utm.join(' · '));
    var klick = ['gclid', 'gbraid', 'wbraid', 'fbclid', 'msclkid'].filter(function (k) { return a[k]; }).map(function (k) { return k + '=' + a[k]; });
    if (klick.length) z.push(klick.join(' · '));
    if (c.branche) z.push('Interesse zuvor: ' + c.branche);
    var info = ['Seite ' + location.pathname, geraet()];
    if (extra && extra.schritte) info.push(extra.schritte + ' Schritte');
    if (extra && extra.dauer) info.push(dauer(extra.dauer));
    z.push(info.join(' · '));
    return z;
  }
  /* bloecke: [{titel: 'KONTAKT', zeilen: ['…']}] -> lesbarer Klartext */
  function nachricht(kopf, bloecke) {
    var out = [kopf, ''];
    bloecke.forEach(function (b) {
      var zeilen = (b.zeilen || []).filter(Boolean);
      if (!zeilen.length) return;
      out.push(b.titel);
      zeilen.forEach(function (z) { out.push('  ' + z); });
      out.push('');
    });
    return out.join('\n').trim();
  }
  function versteckt(form, name, wert) {
    var el = form.querySelector('input[type="hidden"][name="' + name + '"]');
    if (!el) { el = document.createElement('input'); el.type = 'hidden'; el.name = name; form.appendChild(el); }
    el.value = wert == null ? '' : String(wert);
    return el;
  }
  function herkunftFelder(form) {
    var a = herkunft();
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'gbraid', 'wbraid', 'fbclid', 'msclkid'].forEach(function (k) { if (a[k]) versteckt(form, k, a[k]); });
    if (a.landing) versteckt(form, 'einstieg', a.landing);
    if (a.ref) versteckt(form, 'referrer', a.ref);
  }
  function mailto(an, betreff, text) {
    return 'mailto:' + an + '?subject=' + encodeURIComponent(betreff) + '&body=' + encodeURIComponent(String(text || '').slice(0, 1800));
  }

  /* ---------- Versand binden ----------
     Nur die Antwort AUS DEM EIGENEN iframe zaehlt (event.source) und nur vom
     Server, an den das Formular sendet (event.origin). */
  function binden(form, iframe, opt) {
    var herkunftUrl = '';
    try { herkunftUrl = new URL(form.getAttribute('action'), location.href).origin; } catch (e) { herkunftUrl = ''; }
    var uhr = null, aktiv = false;
    window.addEventListener('message', function (ev) {
      if (!ev.data || ev.data.type !== 'picuraFormResult') return;
      if (iframe && ev.source !== iframe.contentWindow) return;
      if (herkunftUrl && ev.origin && ev.origin !== herkunftUrl) return;
      if (!aktiv) return;
      aktiv = false; clearTimeout(uhr);
      if (ev.data.success) { if (opt.erfolg) opt.erfolg(ev.data); }
      else if (opt.fehler) opt.fehler(ev.data.message || '', false);
    });
    return {
      gesendet: function () {
        aktiv = true; clearTimeout(uhr);
        uhr = setTimeout(function () { if (!aktiv) return; aktiv = false; if (opt.fehler) opt.fehler('', true); }, opt.zeit || 20000);
      }
    };
  }

  /* ---------- Rueckruf-Dialog ----------
     Vorlage: snippets/picura-rueckruf.liquid (<template data-picura-rueckruf-vorlage>).
     Ausloeser: jedes Element mit [data-picura-rueckruf]; data-picura-modus="frage"
     macht daraus „Kurze Frage". Ohne Vorlage greift das href (tel:/Kontakt). */
  function rueckrufOeffnen(ausloeser) {
    var vorlage = document.querySelector('template[data-picura-rueckruf-vorlage]');
    if (!vorlage) return false;
    var dlg = document.getElementById('PicuraRueckruf');
    if (!dlg) {
      document.body.appendChild(vorlage.content.cloneNode(true));
      dlg = document.getElementById('PicuraRueckruf');
      if (!dlg) return false;
      rueckrufEinrichten(dlg);
    }
    var modus = (ausloeser && ausloeser.getAttribute('data-picura-modus')) || 'rueckruf';
    dlg.setAttribute('data-modus', modus);
    dlg.dataset.ort = (ausloeser && ausloeser.getAttribute('data-picura-rueckruf')) || 'seite';
    var form = dlg.querySelector('form');
    var k = kontakt();
    if (k.name && !form.elements.rr_name.value) form.elements.rr_name.value = k.name;
    if (k.telefon && !form.elements.rr_telefon.value) form.elements.rr_telefon.value = k.telefon;
    dlg.classList.remove('is-done');
    if (typeof dlg.showModal === 'function') { try { dlg.showModal(); } catch (e) { dlg.setAttribute('open', ''); } }
    else dlg.setAttribute('open', '');
    var erstes = form.querySelector('input:not([type="hidden"]):not([tabindex="-1"])');
    if (erstes) setTimeout(function () { erstes.focus(); }, 30);
    track('picura_contact_click', { method: modus === 'frage' ? 'frage_dialog' : 'rueckruf_dialog', location: dlg.dataset.ort });
    track('picura_form_view', { form_id: modus === 'frage' ? 'frage' : 'rueckruf', page_type: document.body.className.match(/template-[\w-]+/) ? document.body.className.match(/template-[\w-]+/)[0] : '' });
    return true;
  }
  function rueckrufEinrichten(dlg) {
    var form = dlg.querySelector('form');
    var iframe = dlg.querySelector('iframe');
    var meldung = dlg.querySelector('[data-rr-msg]');
    var knopf = form.querySelector('[type="submit"]');
    var erster = 0;
    function zu() { if (typeof dlg.close === 'function') dlg.close(); else dlg.removeAttribute('open'); }
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg || e.target.closest('[data-rr-zu]')) zu();
    });
    form.addEventListener('input', function () { if (!erster) erster = Date.now(); });
    var versand = binden(form, iframe, {
      erfolg: function () {
        knopf.disabled = false; meldung.textContent = '';
        dlg.classList.add('is-done');
        var id = form.querySelector('input[name="lead_id"]');
        lead({ lead_id: id ? id.value : '', form_type: dlg.getAttribute('data-modus') === 'frage' ? 'Kurze Frage' : 'Rückruf-Wunsch', seite: location.pathname, branche: kontext().branche || '' });
      },
      fehler: function (text, zeitueber) {
        knopf.disabled = false;
        meldung.textContent = text || (zeitueber ? 'Keine Antwort vom Server. Bitte rufen Sie uns an: ' + (form.dataset.tel || '') : 'Das hat leider nicht geklappt. Bitte rufen Sie uns an.');
        track('picura_form_fail', { form_id: 'rueckruf', reason: zeitueber ? 'timeout' : 'server' });
      }
    });
    form.addEventListener('submit', function (e) {
      var name = form.elements.rr_name.value.trim();
      var tel = form.elements.rr_telefon.value.trim();
      var frage = form.elements.rr_frage ? form.elements.rr_frage.value.trim() : '';
      var modus = dlg.getAttribute('data-modus');
      meldung.textContent = '';
      if (form.elements.website && form.elements.website.value) { e.preventDefault(); return; }
      if (!name) { e.preventDefault(); meldung.textContent = 'Bitte geben Sie Ihren Namen an.'; form.elements.rr_name.focus(); return; }
      if (!telefonOk(tel)) { e.preventDefault(); meldung.textContent = 'Bitte geben Sie eine Telefonnummer an, unter der wir Sie erreichen.'; form.elements.rr_telefon.focus(); return; }
      if (modus === 'frage' && !frage) { e.preventDefault(); meldung.textContent = 'Bitte schreiben Sie uns kurz Ihre Frage.'; form.elements.rr_frage.focus(); return; }
      if (erster && Date.now() - erster < 2500) {
        e.preventDefault();
        setTimeout(function () { if (form.requestSubmit) form.requestSubmit(); else form.submit(); }, 2600 - (Date.now() - erster));
        return;
      }
      var zeit = form.querySelector('input[name="rr_zeit"]:checked');
      var t = nameTeilen(name);
      var id = leadId();
      var f = fortschritt();
      var bloecke = [
        { titel: 'KONTAKT', zeilen: ['Name: ' + name, 'Telefon: ' + tel, 'Erreichbar: ' + (zeit ? zeit.value : 'So bald wie möglich')] },
        { titel: modus === 'frage' ? 'FRAGE' : 'ANLIEGEN', zeilen: [frage || 'Bitte zurückrufen'] },
        { titel: 'BISHERIGE AUSWAHL', zeilen: f && f.auswahl ? [f.auswahl] : [] },
        { titel: 'HERKUNFT', zeilen: herkunftZeilen() }
      ];
      var kopf = (modus === 'frage' ? 'KURZE FRAGE' : 'RÜCKRUF-WUNSCH') + ' · ' + id + ' · ' + location.pathname;
      versteckt(form, 'lead_id', id);
      versteckt(form, 'name', name);
      versteckt(form, 'vorname', t.vorname);
      versteckt(form, 'nachname', t.nachname);
      versteckt(form, 'telefon', tel);
      versteckt(form, 'phone', tel);
      versteckt(form, 'email', FEHLT);
      versteckt(form, 'form_type', modus === 'frage' ? 'Kurze Frage' : 'Rückruf-Wunsch');
      var text = nachricht(kopf, bloecke);
      versteckt(form, 'nachricht', text);
      versteckt(form, 'message', text);
      versteckt(form, 'seite', location.pathname);
      herkunftFelder(form);
      kontakt({ name: name, telefon: tel });
      knopf.disabled = true;
      meldung.textContent = 'Wird gesendet …';
      versand.gesendet();
    });
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-picura-rueckruf]') : null;
    if (!t) return;
    if (rueckrufOeffnen(t)) e.preventDefault();
  });

  window.PicuraForm = {
    FEHLT: FEHLT,
    leadId: leadId,
    herkunft: herkunft,
    herkunftZeilen: herkunftZeilen,
    herkunftFelder: herkunftFelder,
    kontext: kontext,
    kontakt: kontakt,
    fortschritt: fortschritt,
    track: track,
    lead: lead,
    emailOk: emailOk,
    emailVorschlag: emailVorschlag,
    telefonOk: telefonOk,
    nameTeilen: nameTeilen,
    fehlend: fehlend,
    nachricht: nachricht,
    versteckt: versteckt,
    mailto: mailto,
    binden: binden,
    rueckruf: rueckrufOeffnen,
    geraet: geraet
  };
})();
